import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker';
import FormInputMobile from 'modules/common/components/FormInputMobile';
import useUnitConverter from "modules/common/components/UseUnitConverter";
import Citizenship from 'modules/OHP/healthPermit/components/Citizenship';
import Institution from 'modules/OHP/healthPermit/components/Institution';
import Address from "modules/common/address/Address";
import CmsContext from 'context/CmsContext';
import moment from 'moment';
import CitizenUploadRequirements from '../../components/CitizenUploadRequirements';
import * as actions from '../action';
import * as c from '../constant';

const RULES = {
  tab0: {
    rules: {
      is_citizen: "required",
    },
  },
  tab1: {
    rules: {
      last_name: "required",
      first_name: "required",
      mobile_number: "required|mobile_number_63",
      barangay_code: "required",
      zone: "required",
      address: "required",
      birth_date: 'required',
    },
  },
  tab2: {
    rules: {
      place_of_birth_region_code: 'required',
      place_of_birth_province_code: 'required',
      place_of_birth_municipality_code: 'required',
      place_of_birth_barangay_code: 'required',
    },
  },
  tab5: {
    rules: {
      id_type: 'required',
      id_url: 'required',
      photo: 'required',
    },
  },
};

function StudentModal({
  creatingCitizen,
  createCitizen,
  getStudentList,
  actionType,
  dataInfo,
  id,
  updateCitizen,
  showStudent,
  history,
  getGradeLevelList,
  gradeLevelList
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  const [tab, setTab] = useState(0);
  const [age, setAge] = useState(0);

  const [formData, setFormData] = useState({
    ...c.FORMDATA,
    region_code: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_REGION_FOR_ADDRESS_BILLING") || "",
    province_code: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_PROVINCE_FOR_ADDRESS_BILLING") || "",
    municipality_code: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_MUNICIPALITY_FOR_ADDRESS_BILLING") || "",
    place_of_birth_region_code: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_REGION_FOR_ADDRESS_BILLING") || "",
    place_of_birth_province_code: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_PROVINCE_FOR_ADDRESS_BILLING") || "",
    place_of_birth_municipality_code: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_MUNICIPALITY_FOR_ADDRESS_BILLING") || "",
  });

  const tab0Validator = useFormValidator(
    formData,
    RULES.tab0.rules,
    RULES.tab0.message
  );

  const tab1Validator = useFormValidator(
    formData,
    RULES.tab1.rules,
    RULES.tab1.message
  );

  const tab2Validator = useFormValidator(
    formData,
    RULES.tab2.rules,
    RULES.tab2.message
  );

  const tab5Validator = useFormValidator(
    formData,
    RULES.tab5.rules,
    RULES.tab5.message
  );

  const tab1Field = _.pick(formData, [
    "last_name",
    "first_name",
    "mobile_number",
    "barangay_code",
    "zone",
    "address",
    "birth_date",
  ]);

  const tab2Field = _.pick(formData, [
    "place_of_birth_region_code",
    "place_of_birth_province_code",
    "place_of_birth_municipality_code",
  ]);

  const tab5Field = _.pick(formData, [
    "id_type",
    "id_url",
    "photo",
  ]);

  useEffect(() => {
    tab1Validator.validate();
  }, [Object.values(tab1Field).join(",")]);

  useEffect(() => {
    tab2Validator.validate();
  }, [Object.values(tab2Field).join(",")]);

  useEffect(() => {
    tab5Validator.validate();
  }, [Object.values(tab5Field).join(",")]);

  useEffect(() => {
    getGradeLevelList()
  }, [])

  const validateForm = () => {
    if (tab === 0) {
      if (!tab0Validator.response.is_passed) {
        return false;
      }

      return setTab(+tab + 1);
    }

    if (tab === 1) {
      if (!tab1Validator.response.is_passed) {
        return false;
      }

      return setTab(+tab + 1);
    }

    if (tab === 2) {
      if (!tab2Validator.response.is_passed) {
        return false;
      }
      return setTab(+tab + 1);
    }

    if (tab === 3) {
      return setTab(+tab + 1);
    }

    if (tab === 4) {
      return setTab(+tab + 1);
    }

    if (tab === 5) {
      if (!tab5Validator.response.is_passed) {
        return false;
      }
    }

    return true;
  };

  // const validateFormMobile = useFormValidator(formMobile, {
  //   mobile_number: 'required',
  // });

  const HeightConverter = useUnitConverter("length", "ft", (data) => {
    setFormData({
      ...formData,
      height: data === "NaN" ? 0 : data,
    });
  });

  const WeightConverter = useUnitConverter("mass", "kg", (data) => {
    setFormData({
      ...formData,
      weight: data === "NaN" ? 0 : data,
    });
  });

  // useEffect(() => {
  //   validateFormMobile.validate();
  // }, [Object.values(formMobile).join(',')]);

  useEffect(() => {
    if (actionType === 'EDIT') {
      setFormData({
        mobile_number: _.get(dataInfo, 'mobile_number'),
        is_citizen: _.get(dataInfo, 'is_citizen'),
        type: _.get(dataInfo, 'type'),
        last_name: _.get(dataInfo, 'last_name'),
        first_name: _.get(dataInfo, 'first_name'),
        middle_name: _.get(dataInfo, 'middle_name'),
        extension_name: _.get(dataInfo, 'extension_name'),
        email: _.get(dataInfo, 'email'),
        telephone_number: _.get(dataInfo, 'telephone_number'),
        region_code: _.get(dataInfo, 'region_code'),
        province_code: _.get(dataInfo, 'province_code'),
        municipality_code: _.get(dataInfo, 'municipality_code'),
        barangay_code: _.get(dataInfo, 'barangay_code'),
        zone: _.get(dataInfo, 'zone'),
        address: _.get(dataInfo, 'address'),
        place_of_birth_region_code: _.get(dataInfo, 'place_of_birth_region_code'),
        place_of_birth_province_code: _.get(dataInfo, 'place_of_birth_province_code'),
        place_of_birth_municipality_code: _.get(dataInfo, 'place_of_birth_municipality_code'),
        place_of_birth_barangay_code: _.get(dataInfo, 'place_of_birth_barangay_code'),
        birth_date: _.get(dataInfo, 'birth_date'),
        mother_maiden_last_name: _.get(dataInfo, 'mother_maiden_last_name'),
        mother_maiden_first_name: _.get(dataInfo, 'mother_maiden_first_name'),
        mother_maiden_middle_name: _.get(dataInfo, 'mother_maiden_middle_name'),
        mother_maiden_extension_name: _.get(dataInfo, 'mother_maiden_extension_name'),
        father_last_name: _.get(dataInfo, 'father_last_name'),
        father_first_name: _.get(dataInfo, 'father_first_name'),
        father_middle_name: _.get(dataInfo, 'father_middle_name'),
        father_extension_name: _.get(dataInfo, 'father_extension_name'),
        spouse_last_name: _.get(dataInfo, 'spouse_last_name'),
        spouse_first_name: _.get(dataInfo, 'spouse_first_name'),
        spouse_middle_name: _.get(dataInfo, 'spouse_middle_name'),
        spouse_extension_name: _.get(dataInfo, 'spouse_extension_name'),
        height: _.get(dataInfo, 'height'),
        weight: _.get(dataInfo, 'weight'),
        complexion: _.get(dataInfo, 'complexion'),
        citizenship_code: _.get(dataInfo, 'citizenship_code'),
        educational_attainment: _.get(dataInfo, 'educational_attainment'),
        institution_code: _.get(dataInfo, 'institution'),
        id_type: _.get(dataInfo, 'id_type'),
        id_url: _.get(dataInfo, 'id_url'),
        photo: _.get(dataInfo, 'photo'),
        with_direkta_ayuda: _.get(dataInfo, 'with_direkta_ayuda'),
        with_libre_sakay: _.get(dataInfo, 'with_libre_sakay'),
        grade_level_id: _.get(dataInfo, 'grade_level_id'),
        gender: _.get(dataInfo, 'gender'),
      })
      setAge(_.get(dataInfo, 'age') || 0)
    }
  }, [dataInfo])

  const onChangeDate = key => ({ target: { value } }) => {

    if (key === 'birth_date') {
      const birthYear = moment().diff(moment(value).format('YYYY'), 'years').toString()

      setFormData({
        ...formData,
        [key]: value
      });    
      setAge(birthYear)
    }

    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      mobile_number: _.get(formData, 'mobile_number'),
      institution: _.get(formData, "institution_code"),
      email: _.get(formData, 'email'),
      educational_attainment: _.get(formData, 'educational_attainment'),
      id_url: _.get(formData, 'id_url'),
      photo: _.get(formData, 'photo'),
      last_name: _.get(formData, "last_name").toUpperCase(),
      first_name: _.get(formData, "first_name").toUpperCase(),
      middle_name: (_.get(formData, "middle_name") || '').toUpperCase(),
      mother_maiden_last_name: (_.get(formData, 'mother_maiden_last_name') || '').toUpperCase(),
      mother_maiden_first_name: (_.get(formData, 'mother_maiden_first_name') || '').toUpperCase(),
      mother_maiden_middle_name: (_.get(formData, 'mother_maiden_middle_name') || '').toUpperCase(),
      father_last_name: (_.get(formData, 'father_last_name') || '').toUpperCase(),
      father_first_name: (_.get(formData, 'father_first_name') || '').toUpperCase(),
      father_middle_name: (_.get(formData, 'father_middle_name') || '').toUpperCase(),
      spouse_last_name: (_.get(formData, 'spouse_last_name') || '').toUpperCase(),
      spouse_first_name: (_.get(formData, 'spouse_first_name') || '').toUpperCase(),
      spouse_middle_name: (_.get(formData, 'spouse_middle_name') || '').toUpperCase(),
      with_direkta_ayuda: _.get(formData, 'with_direkta_ayuda') ? 1 : 0,
      with_libre_sakay: _.get(formData, 'with_libre_sakay') ? 1 : 0,
    }

    if (validateForm() !== true) {
      return false;
    }

    if (actionType === 'ADD' && tab === 5) {
      createCitizen(args, (data) => {
        setModal({ isOpen: false });
        getStudentList({ type: 'STUDENT',  sort_by: 'desc' });
        history.push(
          `/social-ameliorations/students/${data.data.id}`
        );
        showStudent(data.data.id);
      });
    }

    if (actionType === 'EDIT' && tab === 5) {
      updateCitizen(id, args, (data) => {
        setModal({ isOpen: false });
        getStudentList({ type: 'STUDENT',  sort_by: 'desc' });
        history.push(
          `/social-ameliorations/students/${data.data.id}`
        );
        showStudent(data.data.id);
      });
    }

    return false
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSelect = (key) => e => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const onChangeResident = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked,
    });
  }

  const onChangeAddress = e => {
    setFormData({
      ...formData,
      region_code: e.target.value.region_code,
      province_code: e.target.value.province_code,
      municipality_code: e.target.value.municipality_code,
      barangay_code: e.target.value.barangay_code,
    });
  };

  const onChangeBirthPlaceAddress = e => {
    setFormData({
      ...formData,
      place_of_birth_region_code: e.target.value.region_code,
      place_of_birth_province_code: e.target.value.province_code,
      place_of_birth_municipality_code: e.target.value.municipality_code,
      place_of_birth_barangay_code: e.target.value.barangay_code,
    });
  };

  const onChangeDecimal = (e) => {
    if (e.target.value && /^\d{1,}(\.\d{0,4})?$/.test(e.target.value)) {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }

    if (!e.target.value) {
      setFormData({
        ...formData,
        [e.target.name]: "",
      });
    }
  };

  const onBlurDecimal = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value ? parseFloat(e.target.value) : "",
    });
  };

  const onChangePhoto = key => data => {
    setFormData({
      ...formData,
      [key]: data.cdnUrl,
    });
  };

  const listOption =
    gradeLevelList.map(item => ({
      label: _.get(item, 'attributes.name'),
      value: _.get(item, 'id'),
    })) || '';

  const paginateButton = () => {
    return (
      <div className="py-1">
        {tab !== 5 && (
          <div className="col-12 d-flex justify-content-center mt-3">
            {tab !== 0 && (
              <button
                type="button"
                onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
                className="btn btn-light button-cancel-2 mr-1"
                style={{ backgroundColor: '#323943', color: '#fff' }}
              >
                Previous
              </button>
            )}
            {tab === 0 && (
              <button
                type="button"
                onClick={closeModal}
                className="btn btn-light button-cancel-2 mr-1"
                style={{ backgroundColor: '#323943', color: '#fff' }}
              >
                Cancel
              </button>
            )}
            <button
              type="submit"
              className="btn btn-light button-proceed ml-1 cms-bg-color-primary text-light"
              disabled={
                (tab === 0 && !tab0Validator.response.is_passed) ||
                (tab === 1 && !tab1Validator.response.is_passed) ||
                (tab === 2 && !tab2Validator.response.is_passed)
              }
            >
              Next
            </button>
          </div>
        )}
        {tab === 5 && (
          <div className="col-12 d-flex justify-content-center mt-3">
            <button
              type="button"
              onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
              className="btn btn-link button-cancel-2 mr-1"
              style={{ backgroundColor: '#323943', color: '#fff' }}
            >
              Previous
            </button>
            <button
              type="submit"
              className='btn btn-light button-proceed ml-1 cms-bg-color-primary'
              style={{ color: '#fff' }}
              disabled={(tab === 5 && !tab5Validator.response.is_passed) || 
                (!tab0Validator.response.is_passed && !tab1Validator.response.is_passed && !tab2Validator.response.is_passed)
              }
            >
              {creatingCitizen ? <i className="fas fa-spinner fa-spin fa-lg" /> : `Submit`}
            </button>
          </div>
        )}
      </div>
    );
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="m-1 p-1">
          {tab === 0 && (
            <div className="d-flex justify-content-start">
              <div className='row'>
                <div className="col-12 cms-text-primary font-weight-bold pb-2">Citizenship</div>
                <div className='col-12 form-group pt-2 mb-0'>
                  <input
                    name="is_citizen"
                    type="checkbox"
                    checked={_.get(formData, 'is_citizen')}
                    onChange={onChangeResident}
                  />
                  <label htmlFor="last_name" className="form-label font-weight-bold ml-2">
                    Is a resident of Borongan? {tab0Validator.renderMessage('is_citizen')}
                  </label>
                </div>
                <div className="col-12 cms-text-primary font-weight-bold pb-2">Program</div>
                <div className='col-12 form-group pt-2 mb-0'>
                  <input
                    name="with_direkta_ayuda"
                    type="checkbox"
                    checked={_.get(formData, 'with_direkta_ayuda')}
                    onChange={onChangeResident}
                  />
                  <label htmlFor="last_name" className="form-label font-weight-bold ml-2">
                    Direkta Ayuda
                  </label>
                </div>
                <div className='col-12 form-group pt-2 mb-0'>
                  <input
                    name="with_libre_sakay"
                    type="checkbox"
                    checked={_.get(formData, 'with_libre_sakay')}
                    onChange={onChangeResident}
                  />
                  <label htmlFor="last_name" className="form-label font-weight-bold ml-2">
                    Libre Sakay
                  </label>
                </div>
              </div>
            </div>
          )}
          {tab === 1 && (
            <div className="row">
              <div className="col-12 cms-text-primary font-weight-bold pb-2">Personal Information</div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-1">
                  Last Name {tab1Validator.renderMessage('last_name')}
                </label>
                <input
                  className="form-control text-uppercase"
                  type="text"
                  name="last_name"
                  onChange={onChange}
                  value={_.get(formData, 'last_name') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-1">
                  First Name {tab1Validator.renderMessage('first_name')}
                </label>
                <input
                  className="form-control text-uppercase"
                  type="text"
                  name="first_name"
                  onChange={onChange}
                  value={_.get(formData, 'first_name') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-1">
                  Middle Name
                </label>
                <input
                  className="form-control text-uppercase"
                  type="text"
                  name="middle_name"
                  onChange={onChange}
                  value={_.get(formData, 'middle_name') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label mb-1">Extension Name:</label>
                <Select
                  options={c.EXTENSION_NAMES}
                  onChange={onSelect('extension_name')}
                  value={
                    c.EXTENSION_NAMES.find(
                      x =>
                        x.value ===
                        _.get(formData, 'extension_name')
                    ) || null
                  }
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label mb-1">
                  Gender: {tab1Validator.renderMessage('gender')}
                </label>
                <Select
                  options={c.GENDER}
                  onChange={onSelect('gender')}
                  value={
                    c.GENDER.find(
                      x =>
                        x.value ===
                        _.get(formData, 'gender')
                    ) || null
                  }
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label mb-1">
                  Date of Birth: {tab1Validator.renderMessage('birth_date')}
                </label>
                <DateInputPicker
                  className="full-input"
                  onChange={onChangeDate('birth_date')}
                  value={_.get(formData, 'birth_date') || ''}
                  maxDate={new Date()}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-1">
                  Age: &nbsp;
                </label>
                <input
                  readOnly
                  className="form-control text-uppercase"
                  type="text"
                  name="age"
                  onChange={onChange}
                  value={age || 0}
                />
              </div>
              <div className="col-12 cms-text-primary font-weight-bold pb-2">Contact Information</div>
              <div className="col-4 form-group">
                <label className="form-label mb-0">
                  E-mail Address
                </label>
                <input
                  className="form-control"
                  type="email"
                  name="email"
                  onChange={onChange}
                  value={_.get(formData, 'email') || ''}
                />
              </div>
              <div className="col-4 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Mobile Number {tab1Validator.renderMessage('mobile_number')}
                </label>
                <FormInputMobile
                  disableDropdown={false}
                  autoComplete="off"
                  type="tel"
                  name="mobile_number"
                  onChange={setFormData}
                  value={formData.mobile_number || ''}
                />
              </div>
              <div className="col-4 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Telephone Number
                </label>
                <InputMask
                  className="form-control"
                  mask="99-9999-9999"
                  alwaysShowMask={false}
                  type="text"
                  name="telephone_number"
                  onChange={onChange}
                  value={_.get(formData, 'telephone_number') || ''}
                />
              </div>
              <div className="col-12 cms-text-primary font-weight-bold pb-2">Address</div>
              <div className='col-12 form-group'>
                <Address
                  value={{
                    region_code: _.get(formData, 'region_code') || '',
                    province_code: _.get(formData, 'province_code') || '',
                    municipality_code: _.get(formData, 'municipality_code') || '',
                    barangay_code: _.get(formData, 'barangay_code') || '',
                  }}
                  onChange={onChangeAddress}
                  region_name="region_code"
                  province_name="province_code"
                  municipality_name="municipality_code"
                  barangay_name="barangay_code"
                  name="Address"
                  withStreet={false}
                  validatorMessage={tab1Validator.renderMessage}
                  removeLabel
                  isDisabled
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Zone {tab1Validator.renderMessage('zone')}
                </label>
                <InputMask
                  className="form-control text-uppercase"
                  type="text"
                  name="zone"
                  onChange={onChange}
                  value={_.get(formData, 'zone') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Unit No. / House No. / Street Name {tab1Validator.renderMessage('address')}
                </label>
                <input
                  className="form-control text-uppercase"
                  type="text"
                  name="address"
                  onChange={onChange}
                  value={_.get(formData, 'address') || ''}
                />
              </div>
            </div>
          )}
          {tab === 2 && (
            <div className="row">
              <div className="col-12 cms-text-primary font-weight-bold pb-2">Place of Birth</div>
              <div className='col-12 form-group'>
                <Address
                  value={{
                    region_code: _.get(formData, 'place_of_birth_region_code') || '',
                    province_code: _.get(formData, 'place_of_birth_province_code') || '',
                    municipality_code: _.get(formData, 'place_of_birth_municipality_code') || '',
                    barangay_code: _.get(formData, 'place_of_birth_barangay_code') || '',
                  }}
                  onChange={onChangeBirthPlaceAddress}
                  region_name="place_of_birth_region_code"
                  province_name="place_of_birth_province_code"
                  municipality_name="place_of_birth_municipality_code"
                  barangay_name="place_of_birth_barangay_code"
                  name="Address"
                  withStreet={false}
                  validatorMessage={tab2Validator.renderMessage}
                  removeLabel
                />
              </div>            
            </div>
          )}
          {tab === 3 && (
            <>
              <div className='row'>
                <div className="col-12 cms-text-primary font-weight-bold pb-2">Mother`s Maiden Name</div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-1">
                    Last Name &nbsp;
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    name="mother_maiden_last_name"
                    onChange={onChange}
                    value={_.get(formData, 'mother_maiden_last_name') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-1">
                    First Name &nbsp;
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    name="mother_maiden_first_name"
                    onChange={onChange}
                    value={_.get(formData, 'mother_maiden_first_name') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-1">
                    Middle Name
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    name="mother_maiden_middle_name"
                    onChange={onChange}
                    value={_.get(formData, 'mother_maiden_middle_name') || ''}
                  />
                </div>
              </div>
              <div className='row'>
                <div className="col-12 cms-text-primary font-weight-bold pb-2">Father`s Name</div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-1">
                    Last Name &nbsp;
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    name="father_last_name"
                    onChange={onChange}
                    value={_.get(formData, 'father_last_name') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-1">
                    First Name &nbsp;
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    name="father_first_name"
                    onChange={onChange}
                    value={_.get(formData, 'father_first_name') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-1">
                    Middle Name
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    name="father_middle_name"
                    onChange={onChange}
                    value={_.get(formData, 'father_middle_name') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label mb-1">Extension Name:</label>
                  <Select
                    options={c.EXTENSION_NAMES}
                    onChange={onSelect('father_extension_name')}
                    value={
                      c.EXTENSION_NAMES.find(
                        x =>
                          x.value ===
                          _.get(formData, 'father_extension_name')
                      ) || null
                    }
                  />
                </div>
              </div>
              <div className='row'>
                <div className="col-12 cms-text-primary font-weight-bold pb-2">Spouse Name</div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-1">
                    Last Name &nbsp;
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    name="spouse_last_name"
                    onChange={onChange}
                    value={_.get(formData, 'spouse_last_name') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-1">
                    First Name &nbsp;
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    name="spouse_first_name"
                    onChange={onChange}
                    value={_.get(formData, 'spouse_first_name') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-1">
                    Middle Name
                  </label>
                  <input
                    className="form-control text-uppercase"
                    type="text"
                    name="spouse_middle_name"
                    onChange={onChange}
                    value={_.get(formData, 'spouse_middle_name') || ''}
                  />
                </div>
              </div>
            </>
          )}
          {tab === 4 && (
            <>
              <div className='row'>
                <div className="col-12 cms-text-primary font-weight-bold pb-2">Identity Information</div>
                <div className="col-6 form-group">
                  <label
                    htmlFor='middle_name'
                    className='form-label mb-0 d-flex'
                  >
                    Height (in ft)
                    <HeightConverter />
                  </label>
                  <input
                    placeholder='0.00'
                    className='form-control text-uppercase'
                    type='text'
                    autoComplete='none'
                    name='height'
                    id='height'
                    onChange={onChangeDecimal}
                    onBlur={onBlurDecimal}
                    value={
                      _.get(formData, "height") || ""
                    }
                  />
                </div>
                <div className="col-6 form-group">
                  <label
                    htmlFor='first_name'
                    className='form-label mb-0 d-flex'
                  >
                    Weight{" "}(in kg)
                    <WeightConverter />
                  </label>
                  <input
                    placeholder='0.00'
                    className='form-control text-uppercase'
                    type='text'
                    autoComplete='none'
                    name='weight'
                    id='weight'
                    onChange={onChangeDecimal}
                    onBlur={onBlurDecimal}
                    value={
                      _.get(formData, "weight") || ""
                    }
                  />
                </div>
                <div className="col-6 form-group">
                  <label
                    htmlFor='first_name'
                    className='form-label mb-0'
                  >
                    Complexion
                  </label>
                  <input
                    placeholder='_'
                    className='form-control text-uppercase'
                    type='text'
                    autoComplete='none'
                    name='complexion'
                    id='complexion'
                    onChange={onChange}
                    value={
                      _.get(formData, "complexion") ||
                      ""
                    }
                  />
                </div>
                <div className="col-6 form-group">
                  <label
                    htmlFor='last_name'
                    className='form-label mb-0'
                  >
                    Country of Citizenship
                  </label>
                  <Citizenship
                    value={
                      _.get(
                        formData,
                        "citizenship_code"
                      ) || "PHL"
                    }
                    name='citizenship_code'
                    onChange={onChange}
                  />
                </div>
              </div>
              <div className='row'>
                <div className="col-12 cms-text-primary font-weight-bold pb-2">Educational Information</div>
                <div className='form-group col-md-6 '>
                  <label className="form-label mb-1">Highest Educational Attainment</label>
                  <Select
                    options={c.HIGHEST_EDUCATIONAL_ATTAINMENT}
                    onChange={onSelect('educational_attainment')}
                    value={
                      c.HIGHEST_EDUCATIONAL_ATTAINMENT.find(
                        x =>
                          x.value ===
                          _.get(formData, 'educational_attainment')
                      ) || null
                    }
                  />
                </div>
                <div className='form-group col-md-6'>
                  <label
                    htmlFor='middle_name'
                    className='form-label mb-2'
                  >
                    Institution
                  </label>
                  <Institution
                    name='institution_code'
                    onChange={onChange}
                    value={
                      _.get(
                        formData,
                        "institution_code"
                      ) || ""
                    }
                  />
                </div>
                <div className='form-group col-md-6'>
                  <label htmlFor="last_name" className="form-label mb-1">
                    Grade / Year
                  </label>
                  <Select
                    onChange={onSelect('grade_level_id')}                  
                    options={listOption}
                    value={listOption.find(item => {
                        return (
                          `${_.get(formData, 'grade_level_id')}` ===
                          _.get(item, 'value')
                        );
                      }) || '' 
                    }
                  />
                </div>
              </div>
            </>
          )}
          {tab === 5 && (
            <>
              <div className="col-12 form-group">
                <label className="form-label mb-1">Valid Id to Upload {tab5Validator.renderMessage('id_type')}
                </label>
                <Select
                  options={c.VALID_IDS}
                  onChange={onSelect('id_type')}
                  value={
                    c.VALID_IDS.find(
                      x =>
                        x.value ===
                        _.get(formData, 'id_type')
                    ) || null
                  }
                />
              </div>
              <div className="col-12 form-group">
                <CitizenUploadRequirements
                  onChange={onChangePhoto}
                  formData={formData}
                  setFormData={setFormData}
                />
              </div>
            </>
          )}
        </div>
        <hr />
        {paginateButton()}
      </form>
    </Modal.Body>
  );
}

StudentModal.defaultProps = {
  actionType: '',
  dataInfo: {},
  id: ''
};

StudentModal.propTypes = {
  creatingCitizen: PropTypes.bool.isRequired,
  createCitizen: PropTypes.instanceOf(Function).isRequired,
  getStudentList: PropTypes.instanceOf(Function).isRequired,
  actionType: PropTypes.string,
  dataInfo: PropTypes.instanceOf(Object),
  id: PropTypes.string,
  updateCitizen: PropTypes.instanceOf(Function).isRequired,
  showStudent: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getGradeLevelList: PropTypes.instanceOf(Function).isRequired,
  gradeLevelList: PropTypes.instanceOf(Object).isRequired
};

const mapStateToProps = ({ api }) => ({
  creatingCitizen: api.loading.indexOf(c.CREATE_CITIZEN) > -1,
  gradeLevelList: _.get(api, `${c.GET_GRADE_LEVEL}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(StudentModal);
